<!-- Header -->
<h3 mat-dialog-title translate>
    Delete Attachment
</h3>

<!-- Body -->
<mat-dialog-content>
    <p translate>
        Are you sure you want to delete this attachment?
    </p>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <tyl-button image="save.png" label="Delete" (clickEvent)="delete()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>
